var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1441_24835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3392 5.16016H10.5017C10.3196 5.16016 10.1464 5.24766 10.0392 5.39766L7.23209 9.29051L5.96066 7.52623C5.85352 7.37801 5.68209 7.28873 5.49816 7.28873H4.66066C4.54459 7.28873 4.47673 7.42087 4.54459 7.51551L6.76959 10.6012C6.82215 10.6746 6.89145 10.7344 6.97172 10.7756C7.052 10.8168 7.14095 10.8384 7.2312 10.8384C7.32145 10.8384 7.4104 10.8168 7.49068 10.7756C7.57095 10.7344 7.64024 10.6746 7.69281 10.6012L11.4535 5.38694C11.5232 5.2923 11.4553 5.16016 11.3392 5.16016Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 14.6429C4.33214 14.6429 1.35714 11.6679 1.35714 8C1.35714 4.33214 4.33214 1.35714 8 1.35714C11.6679 1.35714 14.6429 4.33214 14.6429 8C14.6429 11.6679 11.6679 14.6429 8 14.6429Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1441_24835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.8a279486827b411b6538233bfa1dc940.svg";
export { ForwardRef as ReactComponent };